import React from 'react';
import './style.css';

// Helper function to parse card string and split into Dragon and Tiger cards
const parseCards = (cardString) => {
  if (!cardString) return { dragon: null, tiger: null };
  
  const cards = cardString.split(',');
  return {
    dragon: cards[0]?.trim() ? `/assets/img/cards/${cards[0].trim()}.png` : null,
    tiger: cards[1]?.trim() ? `/assets/img/cards/${cards[1].trim()}.png` : null,
  };
};

// Helper function to parse rdesc
const parseRdesc = (rdesc) => {
  if (!rdesc) return {};
  
  const parts = rdesc.split('#');
  return {
    winner: parts[0] || "",
    pair: parts[1] || "No",
    dragonOddEven: parts[2]?.split('|')[0]?.split(':')[1] || "",
    tigerOddEven: parts[2]?.split('|')[1]?.split(':')[1] || "",
    dragonColor: parts[3]?.split('|')[0]?.split(':')[1] || "",
    tigerColor: parts[3]?.split('|')[1]?.split(':')[1] || "",
    dragonCard: parts[4]?.split('|')[0]?.split(':')[1] || "",
    tigerCard: parts[4]?.split('|')[1]?.split(':')[1] || "",
  };
};

const DT20 = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cards = detailResult?.card ? parseCards(detailResult.card) : { dragon: null, tiger: null };
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || rdescData.winner || "";
  const winValue = detailResult?.win;
  
  const isDragonWinner = winValue === "1" || winner.toLowerCase() === "dragon";
  const isTigerWinner = winValue === "2" || winner.toLowerCase() === "tiger";

  return (
    <div className="row">
      <div className="col-12">
        <h6 className="text-right">
          <b>Round Id :</b> {roundId}
        </h6>
        <div className="text-center luckyseven-img">
          {cards.dragon && (
            <img src={cards.dragon} alt="Dragon Card" onError={(e) => {
              e.target.src = `/assets/img/cards/patti_back.png`;
            }} />
          )}
          {cards.tiger && (
            <img src={cards.tiger} alt="Tiger Card" onError={(e) => {
              e.target.src = `/assets/img/cards/patti_back.png`;
            }} />
          )}
        </div>
        <div className="col-md-12 text-left">
          {winner && (
            <p className="m-b-0 m-t-20">
              <b>Winner:</b> {winner}
            </p>
          )}
          <p className="m-b-0">
            <b>Pair:</b> {rdescData.pair || 'No'}
          </p>
          {(rdescData.dragonOddEven || rdescData.tigerOddEven) && (
            <p className="m-b-0">
              <b>Odd/Even:</b> D : {rdescData.dragonOddEven}  |  T : {rdescData.tigerOddEven}
            </p>
          )}
          {(rdescData.dragonColor || rdescData.tigerColor) && (
            <p className="m-b-0">
              <b>Color:</b> D : {rdescData.dragonColor}  |  T : {rdescData.tigerColor}
            </p>
          )}
          {(rdescData.dragonCard || rdescData.tigerCard) && (
            <p className="m-b-0">
              <b>Card:</b> D : {rdescData.dragonCard}  |  T : {rdescData.tigerCard}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DT20;

